import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~commonInfra/utils/ConnectUtils';
import { fetchResourceActions } from '~src/resourceActions/actions/ResourceActions';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SiteSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedSiteSettingsSpace } from './SiteSettingsSpace';

export interface SpaceInfoProviderDispatchProps {
  readonly enterSpace: (spaceInfo: SpaceInfo) => void;
  readonly requestSpaceContents: () => void;
  readonly fetchResourceActions: () => void;
}

export interface SiteSettingsSpaceProviderOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
  readonly subspaceName: SiteSettingsSubspaceName;
}

export type SiteSettingsSpaceProviderProps = SiteSettingsSpaceProviderOwnProps & SpaceInfoProviderDispatchProps;

function SiteSettingsSpaceProvider(props: SiteSettingsSpaceProviderProps) {
  React.useEffect(() => {
    const enterSpace = props.enterSpace;
    const requestSpaceContents = props.requestSpaceContents;
    const fetchResourceActions = props.fetchResourceActions;
    const subspaceName = props.subspaceName;
    enterSpace({spaceType: 'sitesettings', subspaceName, item: SpaceItemForNonEntitySpace});
    requestSpaceContents();
    fetchResourceActions();
  }, [props.enterSpace, props.requestSpaceContents, props.fetchResourceActions, props.subspaceName]);

  return <ConnectedSiteSettingsSpace {...props} server={getSessionManagementServiceInstance()}/>;
}

const mapDispatchToProps: MapDispatchToProps<SpaceInfoProviderDispatchProps> = (dispatch) => bindActionCreators({
  enterSpace,
  requestSpaceContents,
  fetchResourceActions,
}, dispatch);

export const ConnectedSiteSettingsSpaceProvider: React.ComponentClass<SiteSettingsSpaceProviderOwnProps>
  = connect(null, mapDispatchToProps)(SiteSettingsSpaceProvider);
